import PropTypes from 'prop-types';
import React from 'react';
import { KeyboardAvoidingView, Platform, View } from 'react-native';

/**
 * Cross-platform keyboard avoiding view following Expo's recommended pattern.
 */
function PtfKeyboardAvoidingView({ children, style, behavior, keyboardVerticalOffset = 5, ...otherProps }) {
  // The web doesn't need a Keyboard Avoiding View, and further it causes CPU spikes
  // when co-mounted with map rendering, thus a plain View is used
  if (Platform.OS === 'web') {
    return <View style={style}>{children}</View>;
  }

  return (
    <KeyboardAvoidingView
      style={style}
      // This is the recommended configuration from Expo:
      // https://docs.expo.dev/guides/keyboard-handling/#keyboard-avoiding-view
      // - By itself, the `padding` behavior is enough for iOS to handle the keyboard well
      // - Android also uses the native config `softwareKeyboardLayoutMode=pan` to
      //   pan the view to accommodate the keyboard and not hide inputs
      behavior={behavior || (Platform.OS === 'ios' ? 'padding' : undefined)}
      keyboardVerticalOffset={keyboardVerticalOffset}
      {...otherProps}
    >
      {children}
    </KeyboardAvoidingView>
  );
}

PtfKeyboardAvoidingView.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.any,
  behavior: PropTypes.oneOf(['height', 'position', 'padding']),
  keyboardVerticalOffset: PropTypes.number,
};

export default PtfKeyboardAvoidingView;
